import { hexToOklch, oklchToHex } from "./color.js";
/** Colores de marca Paguz (kit de logo, concepto 09 · Violet flagship). */
export const brand = {
    /** Primario: wordmark, superficies oscuras. */
    navy: '#00306A',
    /** Acento: el punto "pagado", sobre fondos claros. */
    violet: '#6C4EF2',
    /** Acento sobre fondos oscuros/navy (solo texto grande, íconos o decoración). */
    violetLight: '#9D7CFF',
    /** Casi negro para texto. */
    ink: '#0A1E36',
    white: '#FFFFFF',
};
export const SCALE_STEPS = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950];
/** Luminosidad OKLCH objetivo por paso (50 = más claro). */
const LIGHTNESS = {
    50: 0.975,
    100: 0.945,
    200: 0.89,
    300: 0.82,
    400: 0.73,
    500: 0.64,
    600: 0.555,
    700: 0.47,
    800: 0.39,
    900: 0.32,
    950: 0.25,
};
/** Factor de croma por paso: los tonos muy claros se desaturan para no verse fluorescentes. */
const CHROMA_FACTOR = {
    50: 0.14,
    100: 0.25,
    200: 0.45,
    300: 0.68,
    400: 0.88,
    500: 1,
    600: 1,
    700: 0.95,
    800: 0.9,
    900: 0.85,
    950: 0.75,
};
/**
 * Deriva una escala 50–950 en OKLCH manteniendo el tono del color base.
 * El paso ancla conserva el hex exacto de la marca.
 */
export function deriveScale(base, options = {}) {
    const source = hexToOklch(base);
    const anchor = options.anchor ??
        SCALE_STEPS.reduce((best, step) => Math.abs(LIGHTNESS[step] - source.l) < Math.abs(LIGHTNESS[best] - source.l) ? step : best);
    const chroma = Math.min(source.c, options.maxChroma ?? Number.POSITIVE_INFINITY);
    const anchorFactor = CHROMA_FACTOR[anchor];
    const entries = SCALE_STEPS.map((step) => {
        if (step === anchor && options.maxChroma === undefined)
            return [step, base.toUpperCase()];
        const c = (chroma * CHROMA_FACTOR[step]) / anchorFactor;
        return [step, oklchToHex({ l: LIGHTNESS[step], c, h: source.h })];
    });
    return Object.fromEntries(entries);
}
/** Bases de los estados (ajustadas para que sus pares semánticos cumplan AA). */
export const statusBase = {
    success: '#1B8A4B',
    warning: '#D97706',
    danger: '#D2302B',
    info: brand.violet,
};
/** Escalas derivadas. `slate` es el neutro, teñido con el tono del ink. */
export const scales = {
    navy: deriveScale(brand.navy),
    violet: deriveScale(brand.violet),
    slate: deriveScale(brand.ink, { maxChroma: 0.025 }),
    success: deriveScale(statusBase.success),
    warning: deriveScale(statusBase.warning),
    danger: deriveScale(statusBase.danger),
};
//# sourceMappingURL=palette.js.map